<template>

    <v-row  v-resize="onResize" :style="`height:${windowSize.y-130}px;`">
      
      <v-col xs ="12" md="2" >
        <v-card @click="$emit('chiudi')">
          Torna a minisito
        </v-card>
        <v-card :style="`overflow:auto;height:${windowSize.y-170}px;`" >
          <v-card-title>Email Templates</v-card-title>
          <v-card-text>
            <v-row>
              <v-col xs="1" v-for="(item, index) in templatesmail" :key="index">
                <v-card @click="caricatemplate(item)">
                  <v-card-text>{{item.descrizione}}</v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col xs="12" md="10">
        <v-card >
        <v-row  align="center" dense style="padding-left:15px; padding-top:10px">
          <v-btn fab  fixed bottom right color="red" margin="10px" z-index="100" @click="inviamail()"><v-icon>mdi-send</v-icon></v-btn>
        <v-col cols="10">
          <v-text-field dense label="oggetto" v-model="oggettomail"></v-text-field>
        </v-col>
        <v-col cols="10">
          <v-text-field dense label="destinatario" v-model="destinatariomail"></v-text-field>
        </v-col>
        </v-row>
        </v-card>

          <v-row  align="center">
        <v-col cols="12">
          
          <v-card :style="`overflow:auto;height:${windowSize.y-280}px; `" >
          <ckeditor
            :height="windowSize.y-280"
            :editor="editor"
            v-bind:value="value"
            @input="$emit('input', $event)"
            :config="editorConfig"
          ></ckeditor>
          </v-card>

        </v-col>
        </v-row>

      </v-col>
    </v-row>

</template>

<script>
import Vue from "vue";

import CKEditor from "@ckeditor/ckeditor5-vue";
Vue.use(CKEditor);

import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
//import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';

export default {
  components: {
    ckeditor: CKEditor.component
  },
  props: {
    id: {
      type: String
    },
    value: {
      type: String
    },
    admin: {
      type: Boolean
    },
    intemplate: {
      type: undefined
    },
    gestiscitemplate: {
      type: undefined
    },
    htmlenabled: {
      type: String
    }
  },
  data: () => ({
    editor: ClassicEditor,
    editorPlugins: [],
    editorConfig: {
      alignment: {
        options: ["left", "center", "right"]
      },
      toolbar: {
        viewportTopOffset: 30,
        shouldNotGroupWhenFull: true
      }
    },
    windowSize: {
        x: 0,
        y: 0,
      },
    oggettomail: "",
    destinatariomail: ""
  }),
  methods: {
    updateValue: function(value) {
      this.$emit("input", value);
    },
    onResize () {
        this.windowSize = { x: window.innerWidth, y: window.innerHeight }
      },
    caricatemplate: function(item) {
      const payload = {
        Comando: "GetTemplate",
        GUIDPrenotazione: this.$store.state.preventivo.id,
        IdTemplate: item.id
      };
      console.log(payload);
      this.$store.dispatch("APIRequestHR", payload).then(risp => {
        console.log(risp);
        if (risp.data.RISPOSTAOK == -1) {
          this.oggettomail = risp.data.RISULTATOJSON.oggetto;
          this.$emit("input", risp.data.RISULTATOJSON.testo);
        }
      });
    },
    inviamail: function() {
      const payload = {
        Comando: "InvioMail",
        GUIDPrenotazione: this.$store.state.preventivo.id,
        Oggetto: this.oggettomail,
        Testo: this.value
      };
      console.log(payload);
      const me = this;
      this.$store.dispatch("APIRequestHR", payload).then(risp => {
        console.log(risp);
        if (risp.statusText == "OK") {
          me.$emit("inviocompletato", {});
          console.log("innvio completato");
        }
      });
    }
  },
  mounted () {
      this.onResize()
    },
  computed: {
    stile() {
      var s = {};
      if (this.admin) {
        if (this.intemplate) {
          s = { "background-color": "rgba(0, 255, 0, 0.3)" };
        } else {
          s = { "background-color": null };
        }
      }
      return s;
    },
    templatesmail() {
      return this.$store.state.strutture.data[
        this.$store.state.strutturacorrente
      ].template;
    }
  }
};
</script>